import { z } from 'zod';

/**
 * Which line of a member's **introduction** a question's answer is.
 *
 * `MemberProfileView` carries no name — a member is their photograph and the
 * answers the staff's question tree asked for. Which of those answers a viewer
 * recognises somebody by is a fact about the QUESTION, and this is where it is
 * written down: `headline` is the line every list, card and chat header leads
 * with (the family or tribe name, in the seeded catalogue) and `subline` the
 * line under it (the city of residence).
 *
 * Before this existed the headline was implicit — "the first visible answer in
 * `sortOrder`" — which conflated the order a form ASKS in with the order a
 * person is INTRODUCED in. The registration flow rightly asks for the country
 * first (the civil-registry id's format depends on it), so every row in a
 * single-country deployment led with the same country and never a name.
 *
 * Several questions may carry the same role; the first the viewer may see wins,
 * in the tree's order. That is how a fallback chain is expressed (a display
 * name, else the family name) without a second field, and how a member who hid
 * their headline answer is introduced by the next one rather than by nothing.
 *
 * `null` on a question means its answer is an ordinary fact among the others.
 */
export const QUESTION_IDENTITY_ROLES = ['headline', 'subline'] as const;

export const QuestionIdentityRoleSchema = z.enum(QUESTION_IDENTITY_ROLES);

export type QuestionIdentityRole = (typeof QUESTION_IDENTITY_ROLES)[number];
